import { UI } from '@/Components/UI';
import { Difficulty } from '@/Components/Specific';
import { Recipe } from '@/types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

type BaseDataProps = {
    recipe: Recipe,
    servings: number,
    setServings: React.Dispatch<React.SetStateAction<number>>
}

export const BaseData = ({ recipe, servings, setServings }: BaseDataProps) => {
    const { t } = useTranslation(['recipes']);

    const increaseServings = () => {
        setServings((prev) => prev + 1);
    };

    const decreaseServings = () => {
        setServings((prev) => Math.max(1, prev - 1));
    };

    return (
        <>
            <UI.Card>
                <p className={'text-outline'}>
                    {t('difficulty.title')}
                </p>

                <div className={'font-semibold'}>
                    <Difficulty
                        difficulty={recipe.difficulty} />
                </div>
            </UI.Card>

            <UI.Card>
                <p className={'text-outline'}>
                    {t('preparationTime.title')}
                </p>

                <div className={'font-semibold'}>
                    <Trans t={t} i18nKey={'preparationTime.value'}>
                        <UI.Number value={recipe.preparationTime} preset={'decimal'} /> minutes
                    </Trans>
                </div>
            </UI.Card>

            <UI.Card>
                <p className={'text-outline'}>
                    {t('servings.title')}
                </p>

                <div className={'flex flex-col md:flex-row md:items-center justify-between flex-wrap gap-2 md:gap-0'}>
                    <div className={'font-semibold'}>
                        {servings}
                    </div>

                    <div className={'flex gap-2'}>
                        <UI.Button
                            className={'py-1'}
                            buttonStyle={'tonal'}
                            type={'button'}
                            disabled={servings === 1}
                            onClick={decreaseServings}
                            aria-label={t('servings.decrease')}>
                            -
                        </UI.Button>
                        <UI.Button
                            className={'py-1'}
                            buttonStyle={'tonal'}
                            type={'button'}
                            onClick={increaseServings}
                            aria-label={t('servings.increase')}>
                            +
                        </UI.Button>
                    </div>
                </div>
            </UI.Card>
        </>
    );
};
